var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestionHint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9182 8.63806C11.5287 7.64275 12.0002 6.80594 12.0002 5.8085C12.0002 3.45167 10.1776 1.5998 8.0002 1.5998C5.8228 1.5998 4.0002 3.45167 4.0002 5.8085C4.0002 6.8163 4.48218 7.73788 5.08929 8.76733C5.1302 8.8367 5.1719 8.90697 5.21404 8.97799C5.46835 9.40656 5.7388 9.86233 5.94938 10.311C6.0902 10.611 6.21639 10.9316 6.2992 11.2694H9.68446C9.88208 10.3196 10.3915 9.493 10.8254 8.78901C10.8568 8.73805 10.8878 8.68774 10.9182 8.63806ZM10.4002 12.0694C10.4002 11.0103 10.9608 10.0974 11.5402 9.15414C12.1595 8.14571 12.8002 7.10246 12.8002 5.8085C12.8002 3.04227 10.6512 0.799805 8.0002 0.799805C5.34923 0.799805 3.2002 3.04227 3.2002 5.8085C3.2002 7.15058 3.88944 8.31285 4.52921 9.39167C5.08326 10.326 5.6002 11.1977 5.6002 12.0694H6.4002H9.6002H10.4002Z",
    fill: "#EB0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59961 12.6953H10.3996V12.7997C10.3996 13.2846 10.3996 13.5271 10.3551 13.7279C10.1971 14.4406 9.64053 14.9971 8.92788 15.1551C8.72705 15.1997 8.48457 15.1997 7.99961 15.1997C7.51465 15.1997 7.27217 15.1997 7.07134 15.1551C6.35869 14.9971 5.80212 14.4406 5.64413 13.7279C5.59961 13.5271 5.59961 13.2846 5.59961 12.7997V12.6953Z",
    fill: "#EB0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionHint);
export default __webpack_public_path__ + "static/media/icon_question_hint.dc5eea44d23050fe1b0ed80549c67ef2.svg";
export { ForwardRef as ReactComponent };